import { render } from "./TermEditTableHeader.vue?vue&type=template&id=1a13ba9d&scoped=true&ts=true"
import script from "./TermEditTableHeader.vue?vue&type=script&lang=ts"
export * from "./TermEditTableHeader.vue?vue&type=script&lang=ts"

import "./TermEditTableHeader.vue?vue&type=style&index=0&id=1a13ba9d&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a13ba9d"]])

export default __exports__